import React from 'react';
import classNames from 'classnames';

import cn from './InputLabel.module.scss';

const InputLabel = ({ text, error, required }) => {
  return (
    <div
      className={classNames(cn.label, {
        [cn.error]: !!error,
      })}
    >
      {required && <span className={cn.error}>*</span>}
      {text}
    </div>
  );
};

export default InputLabel;
